import { Team, TeamRole } from '@this+that/models';

const rolePriority: Record<TeamRole, number> = {
  [TeamRole.OWNER]: 1,
  [TeamRole.ADMIN]: 2,
  [TeamRole.CONSULTANT]: 3,
  [TeamRole.MEMBER]: 4,
  [TeamRole.VIEWER]: 5,
};
export const sortByUserRole = (users: Team[]) =>
  [...users].sort((a, b) => {
    const priorityA = rolePriority[a.userRole ?? 'member'];
    const priorityB = rolePriority[b.userRole ?? 'member'];
    return priorityA - priorityB;
  });
